var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: { type: "search", placeholder: _vm.$t("SEARCH") },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isLoading
        ? _c("div", { staticClass: "m-t-10 m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm m-r-5",
                attrs: {
                  "data-testid": "add-integration-button",
                  type: "button",
                  disabled: _vm.isAddFormOpen
                },
                on: { click: _vm.showAddForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PLATFORMS_ADD_BUTTON",
                      expression: "'PLATFORMS_ADD_BUTTON'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.integrations,
                    "current-page": _vm.currentPage,
                    filters: _vm.filters,
                    "page-size": 20,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              !_vm.integrations.length
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "PLATFORMS_HEADER_NONE",
                                          expression: "'PLATFORMS_HEADER_NONE'"
                                        }
                                      ],
                                      attrs: { colspan: "100" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isAddFormOpen
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          _c("PlatformForm", {
                                            on: { closeForm: _vm.hideAddForm }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.showEditForm(
                                                      row.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(row.name) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.transformPlatformType(
                                                    row.type
                                                  )
                                                ) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.status) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("PlatformActions", {
                                                    attrs: {
                                                      integration: row,
                                                      disabled: _vm.isDisabled,
                                                      "integration-to-reset":
                                                        _vm.integrationToReset
                                                    },
                                                    on: {
                                                      deleteIntegration:
                                                        _vm.showDeleteModal,
                                                      refreshIntegration:
                                                        _vm.refreshIntegration,
                                                      editIntegration: function(
                                                        $event
                                                      ) {
                                                        return _vm.showEditForm(
                                                          row.id
                                                        )
                                                      },
                                                      toggleEnabled:
                                                        _vm.toggleIntegrationEnabled,
                                                      collapseActions: function(
                                                        $event
                                                      ) {
                                                        !_vm.isDisabled &&
                                                          _vm.hideMobileAction()
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("PlatformActions", {
                                                attrs: {
                                                  integration: row,
                                                  disabled: _vm.isDisabled,
                                                  "integration-to-reset":
                                                    _vm.integrationToReset
                                                },
                                                on: {
                                                  deleteIntegration:
                                                    _vm.showDeleteModal,
                                                  refreshIntegration:
                                                    _vm.refreshIntegration,
                                                  editIntegration: function(
                                                    $event
                                                  ) {
                                                    return _vm.showEditForm(
                                                      row.id
                                                    )
                                                  },
                                                  toggleEnabled:
                                                    _vm.toggleIntegrationEnabled,
                                                  collapseActions: function(
                                                    $event
                                                  ) {
                                                    !_vm.isDisabled &&
                                                      _vm.hideMobileAction()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isEditFormOpen(row.id)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("PlatformForm", {
                                                attrs: { integration: row },
                                                on: {
                                                  closeForm: _vm.hideEditForm
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    251765155
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "PLATFORM_NAME_LABEL",
                              expression: "'PLATFORM_NAME_LABEL'"
                            }
                          ],
                          attrs: { "default-sort": "asc", "sort-key": "name" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "PLATFORMS_TYPE",
                              expression: "'PLATFORMS_TYPE'"
                            }
                          ],
                          attrs: { "sort-key": "type" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "PLATFORMS_STATUS",
                              expression: "'PLATFORMS_STATUS'"
                            }
                          ],
                          attrs: { "sort-key": "type" }
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.integrations && _vm.integrations.length
                ? _c("div", { staticClass: "pagination-min" }, [
                    _c(
                      "div",
                      { staticClass: "text-center p-7" },
                      [
                        _c("smart-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "total-pages": _vm.totalPages,
                            "max-page-links": 7
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.currentPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.currentPage = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "PLATFORMS_TABLE_LOADING",
                    expression: "'PLATFORMS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.isDeleteModalOpen
        ? _c("PlatformDeleteModal", {
            attrs: {
              integration: _vm.integrationToDelete,
              "is-deleting": _vm.isDeletingIntegration
            },
            on: {
              closeModal: _vm.closeDeleteModal,
              deleteIntegration: _vm.confirmDeleteIntegration
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }